module.exports = __webpack_public_path__ + "static/media/apollo_calculation_rules.26cdbcbb.pdf";